import { ENV, environmentVariable } from '@application/env';
import fetch from 'cross-fetch';

interface TranslateTextParams {
  originalLang: string | undefined | null;
  targetLang: string;
  textToTranslate: string;
  format: 'text' | 'html';
}

const serverUrl = environmentVariable(ENV.SERVER_URL);

export const translateText = async (params: TranslateTextParams) => {
  const path = 'translate';
  const searchParams = new URLSearchParams({
    targetLang: params.targetLang,
    textToTranslate: params.textToTranslate,
    format: params.format,
    ...(params.originalLang && { originalLang: params.originalLang }),
  });
  const response = await fetch(`${serverUrl}${path}?${searchParams}`, {
    method: 'get',
    headers: {
      'Cache-Control': 'public, max-age=604800',
    },
  })
    .then((data) => data.json())
    .catch((err) => {
      console.error(err);
      return '';
    });

  return response?.translatedText;
};
